const EMPTY_ARRAY = [];

const normalizeThreadContentItem = (threadId, threadContentItem) => {
  const normalizedThreadId = String(threadContentItem?.threadId || threadId || '').trim();

  if (!normalizedThreadId) {
    return null;
  }

  return {
    ...(threadContentItem || {}),
    threadId: normalizedThreadId
  };
};

const buildThreadContentItems = (threadContent = EMPTY_ARRAY) => {
  if (Array.isArray(threadContent)) {
    if (threadContent.length < 1) {
      return EMPTY_ARRAY;
    }
  } else if (!threadContent || typeof threadContent !== 'object') {
    return EMPTY_ARRAY;
  }

  const sourceEntries = Array.isArray(threadContent) ? EMPTY_ARRAY : Object.entries(threadContent);

  if (!Array.isArray(threadContent) && sourceEntries.length < 1) {
    return EMPTY_ARRAY;
  }

  const nextItems = [];
  const itemIndexByThreadId = {};
  const sourceItems = Array.isArray(threadContent)
    ? threadContent
    : sourceEntries.map(([threadId, threadContentItem]) => {
        return normalizeThreadContentItem(threadId, threadContentItem);
      });

  for (const sourceItem of sourceItems) {
    const normalizedItem = normalizeThreadContentItem(sourceItem?.threadId, sourceItem);

    if (!normalizedItem) {
      continue;
    }

    const threadId = normalizedItem.threadId;
    const existingIndex = itemIndexByThreadId[threadId];

    if (Number.isInteger(existingIndex)) {
      nextItems[existingIndex] = normalizedItem;
      continue;
    }

    itemIndexByThreadId[threadId] = nextItems.length;
    nextItems.push(normalizedItem);
  }

  return nextItems.length > 0 ? nextItems : EMPTY_ARRAY;
};

export default buildThreadContentItems;
